import React, { SVGProps } from 'react'

import { Colors } from 'common-constants/colors'

export const SmileInCircleSvg = ({
  color = Colors.link,
  ...rest
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <rect width={20} height={20} rx={10} fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15ZM8.30722 10.0094C8.68714 10.0094 8.99513 9.70144 8.99513 9.32151C8.99513 8.94158 8.68714 8.63359 8.30722 8.63359C7.92729 8.63359 7.6193 8.94158 7.6193 9.32151C7.6193 9.70144 7.92729 10.0094 8.30722 10.0094ZM12.4951 9.32151C12.4951 9.70144 12.1871 10.0094 11.8072 10.0094C11.4273 10.0094 11.1193 9.70144 11.1193 9.32151C11.1193 8.94158 11.4273 8.63359 11.8072 8.63359C12.1871 8.63359 12.4951 8.94158 12.4951 9.32151ZM7.5825 12.2621C7.58222 12.2618 7.58195 12.2614 7.58183 12.261C7.53086 12.182 7.5 12.0858 7.5 11.9812C7.5 11.7154 7.6933 11.5001 7.93147 11.5001C7.98365 11.5001 8.03299 11.5119 8.07929 11.5309C8.0793 11.5309 8.07955 11.531 8.08003 11.5311C8.1225 11.544 9.97469 12.1086 11.8529 11.5667C11.9166 11.5254 11.9895 11.5001 12.0685 11.5001C12.3069 11.5001 12.5 11.7154 12.5 11.9812C12.5 12.1091 12.4545 12.2248 12.3814 12.3111C12.3814 12.3111 11.6371 13.4999 9.96193 13.4999C9.96193 13.4999 8.71096 13.544 7.67259 12.3638C7.63848 12.335 7.60822 12.3013 7.58305 12.2628C7.58288 12.2626 7.58269 12.2623 7.5825 12.2621Z"
      fill="white"
    />
  </svg>
)
